module.exports = __webpack_public_path__ + "2b0003d6af98a87f314144ea789a75b4.png";